import { Injectable } from '@angular/core';
import { ButtonTheme } from '@rd/types/button-theme.type';

export type InsufficientMilesIconType = 'failed' | 'warning';

@Injectable({
  providedIn: 'root',
})
export class PopupSettingService {
  singleButtonTheme: ButtonTheme = 'primary';

  insufficientMilesIconType: InsufficientMilesIconType = 'failed';

  userIdleDialogButtonTheme: ButtonTheme = 'primary';

  shouldRenderCheckoutErrorDialogTitle = true;

  // AuthSecureRouteDialog settings
  shouldRenderRegisterLink = true;
  shouldRenderLoginButton = true;
}
